import {FC} from 'react';
import styles from "@/styles/Ui.module.scss"
import Images from "@/utils/images.ts";
import clsx from "clsx";


interface Props {
    is_init:boolean
}


const LoadingScreen: FC<Props>  = ({is_init}) => {
    
    return (
        <section className={clsx(styles.loadin_screen, is_init && styles.transparent)}>
            <img src={Images.logos.LogoSimple} alt={"logo"} width={180} height={48} />
        </section>
    )
}

export default LoadingScreen